import React from 'react';
import { useLocation } from 'react-router-dom';
import { hasAccountRole } from '@/lib/account-roles';
import {
  useActiveOrgQuery,
  useAllOrgsQuery,
  useImpersonateOrgMutation,
} from '@/queries/org';
import { useAuthStore } from '@/stores/auth-store';

export default function OrgSwitcher() {
  const location = useLocation();
  const pathname = (location.pathname ?? '/').replace(/\/$/, '') || '/';
  const isMainScreen = pathname === '/';

  const currentUser = useAuthStore((s) => s.currentUser);
  const isRoot = hasAccountRole(currentUser, 'ROOT');
  const queryEnabled = isRoot;

  const { data: activeOrg, isPending: activeOrgLoading } = useActiveOrgQuery({
    enabled: queryEnabled,
  });
  const { data: allOrgs = [], isPending: orgsLoading } = useAllOrgsQuery({
    enabled: queryEnabled,
  });
  const impersonate = useImpersonateOrgMutation();

  if (!isRoot) {
    return null;
  }

  const activeOrgId = activeOrg?.orgId;
  const loading = activeOrgLoading || orgsLoading || impersonate.isPending;
  const controlsDisabled = loading || activeOrgId == null || !isMainScreen;
  const showReset = activeOrg?.impersonated === true;

  const handleChange = (event) => {
    const orgId = Number(event.target.value);
    if (!Number.isFinite(orgId) || orgId === activeOrgId) {
      return;
    }
    impersonate.mutate(orgId);
  };

  const handleReset = () => {
    impersonate.mutate(0);
  };

  return (
    <div className="bethere-org-switcher">
      <select
        id="org-switcher"
        className="bethere-org-switcher-select"
        value={activeOrgId != null ? String(activeOrgId) : ''}
        disabled={controlsDisabled}
        onChange={handleChange}
        aria-label="Switch organization"
      >
        {activeOrgId == null && (
          <option value="" disabled>
            {loading ? 'Loading organizations…' : 'No organization'}
          </option>
        )}
        {allOrgs.map((org) => (
          <option key={org.orgId} value={String(org.orgId)}>
            {org.orgName}
          </option>
        ))}
      </select>
      {showReset && (
        <button
          type="button"
          className="bethere-org-switcher-reset-btn"
          disabled={controlsDisabled}
          onClick={handleReset}
        >
          Reset
        </button>
      )}
    </div>
  );
}
